import React from 'react';
import {
  Container,
  MarginBox,
  LinksContent,
  Column,
  Copyright,
  SocialLinks
} from './DesktopFooter.style';
import footerLinks from './footerLinks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

import { useTranslation } from 'react-i18next';

const DesktopFooter = () => {
    const { t } = useTranslation();
  return (
    <Container>
        <MarginBox>   
            <Column>
                <Copyright style={{ marginTop: '20px' }}>@2020 Bizdocs. Todos os direitos reservados</Copyright>
            </Column>
              <Column>
                  <LinksContent style={{ width: '200px' }}>

                      <SocialLinks>
                          <a href="mailto:info@bizdocs.mobi"><FontAwesomeIcon icon={faEnvelope} style={{fontSize: '25px'}}/></a>

                          {footerLinks.social.map(social => (
                              <a key={social.alt} href={social.to} rel="noopener noreferrer" target="_blank">{social.logo}</a>
                          ))}
                      </SocialLinks>
                  </LinksContent>    
              </Column>
       
      </MarginBox>
    </Container>
  );
};

export default DesktopFooter;

/*<Container>
      <MarginBox>
        <Column>
          <LinksContent>
            <Title>{t('footer_title1')}</Title>
            {footerLinks.about.map(link => (
              <Links to={link.link} key={link.text}>
                    {t(link.text)}
              </Links>
            ))}
          </LinksContent>
        </Column>
        <Column>
          <LinksContent>
            <Title>{t('footer_title2')}</Title>
            {footerLinks.portal.map(link => (
                <Links key={link.text} to=""> {t(link.text)}</Links>
            ))}
          </LinksContent>
          <LinksContent>
            <Title style={{ marginTop: '50px' }}>{t('footer_title3')}</Title>
            {footerLinks.empresas.map(link => (
                <Links key={link.text} to=""> {t(link.text)}</Links>
            ))}
          </LinksContent>
        </Column>
        <Column>
          <LinksContent>
          <Title>{t('footer_title4')}</Title>
            {footerLinks.login.map(link => (
                <Links key={link.text} to={link.link}> {t(link.text)}</Links>
            ))}
          </LinksContent>
        </Column>
        <Column>
        <LinksContent>
            <Title>{t('footer_title5')}</Title>
            <p style={{ marginTop: '10px' }}>+351 220 149 690</p>
            <div style={{ marginTop: '10px' }}>
                <FontAwesomeIcon icon={faEnvelope} />
                <a href="mailto:info@bizdocs.mobi">info@bizdocs.mobi</a>
            </div>
        </LinksContent>
            <LinksContent>
             <Title style={{ marginTop: '50px' }}>{t('footer_title6')}</Title>
                <SocialLinks>
                    {footerLinks.social.map(social => (
                        <a key={social.alt} href={social.to} rel="noopener noreferrer" target="_blank">{social.logo}</a>
                    ))}
                </SocialLinks>
            </LinksContent>
                  <Title style={{ marginTop: '56px' }}>{t('footer_title7')}</Title>
                  <img src={ImageLatourrette} alt="imag" style={{ maxHeight: '2.5vh' }} />
                  <img src={Image2020} alt="imag" style={{ maxHeight: '3.5vh', marginTop: '20px' }} />
                  <Copyright style={{ marginTop: '20px' }}>{t('footer_title7_item1')}</Copyright>
        </Column>
      </MarginBox>
    </Container>*/